import { Dialog, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { normalizeText } from 'utils/normalize';
import { SearchInput } from 'v3/shared/components/Inputs/SearchInput';
import { SubtitleLargeBold } from 'v3/shared/typography/SubtitleLarge';
import { AlignRowBetween, CloseIconStyled, Container, dialogStyles, Header, Item, ItemContainer, List } from './styles';
import { DialogDataSelectProps, IData } from './types';

export const DialogDataSelect: React.FC<DialogDataSelectProps> = ({
  setOpen,
  open,
  data,
  setSelectItem,
  title,
  hideSearch,
}) => {
  const theme = useTheme();
  const [search, setSearch] = useState<string>('');
  const [dataList, setDataList] = useState<IData[]>(data);

  const containsText = (text: any, searchText: any) => {
    const textNormalized = normalizeText(text.key);
    const textArray = textNormalized.split(' ');
    const foundText = textArray.map((text: string) => text.startsWith(searchText));
    return foundText.includes(true);
  };

  const handleOptions = (value: string) => {
    setSearch(value);
    const valueNormalized = normalizeText(value);
    const options = value ? dataList.filter((op: object) => containsText(op, valueNormalized)) : data;
    setDataList(options);
  };

  const selectItem = (item: string) => {
    setSelectItem(item);
    handleClose();
  };

  const handleClose = () => setOpen(false);
  const listBack = () => setDataList(data);

  useEffect(() => {
    setDataList(data);
  }, [data]);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth={false}
      PaperProps={{
        style: dialogStyles(theme),
      }}
    >
      <Container>
        <Header>
          <AlignRowBetween>
            <SubtitleLargeBold>{title}</SubtitleLargeBold>
            <CloseIconStyled onClick={handleClose} />
          </AlignRowBetween>

          {hideSearch ? null : (
            <SearchInput
              name="search"
              value={search}
              label={title}
              placeholder={'Buscar'}
              onChange={handleOptions}
              onKeyDown={(event) => {
                if (event.key !== 'Escape') event.stopPropagation();
                if (event.key === 'Backspace') listBack();
              }}
            />
          )}
        </Header>

        <List>
          {dataList.map((item: IData, index: number) => (
            <ItemContainer key={`item-container-${index}`}>
              <Item key={`${item.key}-${index}`} id={`${item.key}-${index}`} onClick={() => selectItem(item.value)}>
                {item.key}
              </Item>
            </ItemContainer>
          ))}
        </List>
      </Container>
    </Dialog>
  );
};
